export const siteInfo = {
  name: "在线漫画韩漫",
  fullName: "在线漫画韩漫 - 免费大全韩国漫画平台",
  description: "在线漫画韩漫平台提供免费大全韩国漫画资源，支持多语言翻译与个性化推荐，为您带来沉浸式阅读体验，每日更新热门韩漫作品。",
  keywords: "在线漫画韩漫,免费大全,韩国漫画平台,多语言韩漫,个性化推荐,免费韩漫在线,韩国漫画大全",
  url: "http://xinxiust.com/",
  phone: "400-888-0000",
  email: "hello@xinxiust.com",
  address: "北京市朝阳区望京SOHO T3-A 2501",
  weibo: "http://xinxiust.com/",
  wechat: "hanman_official",
  bilibili: "http://xinxiust.com/",
  foundingYear: "2021",
};